import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { Section, InputGrid, InputRow, InputField, ContinueButton, NotificationBanner } from '@parchment/ui-primitives';
import AiWarning from '@parchment/ui-icons/lib/ai/warning';
import _ from 'underscore';
import '../style/LoginPage.less';

export default class LoginPage extends Component {

    static get propTypes() {
        return {
            authenticateNewUser: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            authenticateNewUser: () => {}
        };
    }

    get valid() {
        return !this.state.loading && _.reduce(_.values(this.state.valid), (a, b) => a && b, true);
    }

    constructor(props) {
        super(props);
        this.forgotPassword = this.forgotPassword.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            email: '',
            password: '',
            loading: false,
            valid: {
                email: false,
                password: false
            }
        };
    }

    isValid(field) {
        return this.state.valid[field];
    }

    handleValidation(field) {
        return () => {

            let valid = this.state[field] !== '';
            if(valid && field === 'email') {
                valid = /^[^@]+@[^.@]+\.[^@]+$/.test(this.state.email);
            }

            this.setState({valid: {...this.state.valid, [field]: valid}});
        };
    }

    validationProps(field, label) {
        return {
            required: true,
            labelAsPlaceHolder: true,
            name: field,
            label,
            value: this.state[field],
            onChange: (value) => this.setState({[field]: value},
                this.handleValidation(field)),
            onBlur: this.handleValidation(field),
            valid: this.isValid(field)
        };
    }

    onSubmit(e) {
        e.preventDefault();
        if(this.valid) {
            this.setState({loading: true});
            this.props.authenticateNewUser(this.state.email,
                this.state.password, this.props.params.memberId)
            .then((resp) => {
                if (resp.payload.data.needsVerified) {
                    this.props.router.push(
                        `/u/registration/${this.props.params.memberId}/institution/confirm`);
                } else {
                    window.location.href = `/u/auth/login?memberId=${this.props.params.memberId}`;
                }
                this.setState({loading: false});
            })
            .catch((err) => {
                console.warn('Login failed', err);
                this.setState({
                    loginFailed: true,
                    loading: false,
                    password: '',
                    valid: {
                        password: false
                    }});
            });
        }
    }

    forgotPassword() {
        const returnUrl = encodeURIComponent(
            `/u/registration/${this.props.params.memberId}/institution#/tpo/login`
        );

        window.location.href=`/u/auth/forgot?returnUrl=${returnUrl}`;
    }

    renderErrors() {
        if(this.state.loginFailed) {
            return (<NotificationBanner closeButton
                                        className="error"
                                        icon={<AiWarning />}>
                Please enter a valid username/e-mail and password
            </NotificationBanner>);
        }
    }

    handleEnterAsOnClick(fn) {
        return (e) => {
            if (e.key === 'Enter') {
                fn(e);
            }
        }
    }

    render() {
        return (<Section additionalClasses="default wildSand login-page-container" shadow="top">
            {this.renderErrors()}
            <div className="row">
                <h5 className="bold">SIGN IN TO YOUR PARCHMENT ACCOUNT
                    <span className="pull-right color-boulder italic sign-in-link" onClick={this.forgotPassword} onKeyUp={this.handleEnterAsOnClick(this.forgotPassword)} role="link" tabIndex="0">Forgot your password?</span>
                </h5>
                <Form autoComplete="off" onSubmit={this.onSubmit} onKeyUp={this.handleEnterAsOnClick(this.onSubmit)}>
                    <InputGrid>
                        <InputRow>
                            <InputField
                                {...this.validationProps('email', 'Email Address')}
                                type="text" className="col-xs-6" />
                            <InputField
                                {...this.validationProps('password', 'Password')}
                                type="password" className="col-xs-6" />
                        </InputRow>
                        <InputRow>
                            <ContinueButton block className="primary" type="button" onClick={this.onSubmit} enabled={this.valid} isLoading={this.state.loading} buttonLabel="SIGN IN" />
                        </InputRow>
                    </InputGrid>
                </Form>
            </div>
        </Section>);
    }
};
